export default __webpack_public_path__ + "static/media/user.42605f35.png";